import { Menu, MenuItem } from "@mui/material";
import React from "react";

export const AddMenu = (props) => {
  const {
    anchorEl,
    handleClose,
    setOther,
    setSelectEmployee,
  } = props;
  const open = Boolean(props.anchorEl);
  return (
    <Menu
      id="basic-menu"
      anchorEl={anchorEl}
      open={open}
      onClose={handleClose}
      MenuListProps={{
        "aria-labelledby": "basic-button",
      }}>
      {/* <MenuItem
        onClick={() => {
          if (hideRole) {
            setCategory("structure");
            setSelect(true);
            handleClose();
          }
        }}>
        From User
        {hideRole ? null : <><span>:{" "}</span><select
          onChange={(e) => {
            setCategory(e.target.value);
            setSelect(true);
            handleClose();
          }} >
          <option>{"Select---"}</option>
          {["role", "structure"].map((title) => (
            <option value={title}>{title}</option>
          ))}
        </select></>}
      </MenuItem> */}
      <MenuItem
        onClick={() => {
          setSelectEmployee(true);
          handleClose();
        }}>
        From Employee
      </MenuItem>
      <MenuItem
        onClick={() => {
          setOther(true);
          handleClose();
        }}>
        Other
      </MenuItem>
    </Menu>
  );
};
